import { atom } from 'recoil';
import { JwtToken } from '../types/user.type';
import { recoilPersist } from "recoil-persist";
// import { IFileTypes, IFileTypesList } from '../components/layout/drag.drop.file';

const { persistAtom } = recoilPersist();

// user atom 
export type UserType = {
    showModeratorBoard: boolean,
    showAdminBoard: boolean,
    currentUser: JwtToken | undefined
  }
export const initUserType = {
    showModeratorBoard: false,
    showAdminBoard: false,
	currentUser : undefined
}
export const UserTypeAtom = atom<UserType>({
	key: 'UserTypeAtom',
	default: initUserType,
    effects_UNSTABLE: [persistAtom],
});

export const MemberIdSave = atom<string>({
    key: 'MemberIdSave',
    default: localStorage.getItem('MemberIdSave') || '', // 로컬 스토리지에서 초기값 가져오기
});

export const ClubSeqSave = atom<any>({
    key: 'ClubSeqSave',
    default: localStorage.getItem('ClubSeqSave') || '',// 로컬 스토리지에서 초기값 가져오기
});

export const TokenSave = atom<any>({
    key: 'TokenSave',
    default: localStorage.getItem('TokenSave') || '',// 로컬 스토리지에서 초기값 가져오기
});

// TEST atom
export const globalIdAtom = atom({
	key: 'globalId',
	default: "admin",
    effects_UNSTABLE: [persistAtom],
});

